import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import {Modal} from "@softline/ui-core";
import { KundeninfoLeiste, KundeninfoLeisteComponent } from '@softapps/fibu/core';

import { TranslatePipe } from '@softline/ui-core';
@Component({
    selector: 'soft-kontoinformationen-anzeigen',
    imports: [CommonModule,
    TranslatePipe],
    templateUrl: './kontoinformationen-anzeigen-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./kontoinformationen-anzeigen-dialog.component.css']
})
export class KontoinformationenAnzeigenDialogComponent implements Modal<KundeninfoLeisteComponent> {

  public _kontoInformationen!: KundeninfoLeiste;

  set kontoInformationen(kontoInformationen: KundeninfoLeiste) {
    this._kontoInformationen = kontoInformationen;
  }

  close!: (result: KundeninfoLeisteComponent) => void;
  registerCloseHandler(handler: (result: KundeninfoLeisteComponent) => void): void {
    this.close = handler;
  }
}
